import { InputNumber, Select } from "antd";
import { Flex } from "src/components/Flex";
import { attributeToTitle } from "src/utils/strings";

export type SearchWindowConfig = {
  limit: number;
  sortBy: "default" | string;
  sortDirection: "ascending" | "descending";
};

export function toSearchWindowConfig(
  data: SearchWindowConfig | any
): SearchWindowConfig {
  return {
    limit: typeof data?.limit === "number" ? data.limit : 0,
    sortBy: typeof data?.sortBy === "string" ? data.sortBy : "default",
    sortDirection: ["ascending", "descending"].includes(data?.sortDirection)
      ? data.sortDirection
      : "ascending",
  };
}

export function SearchWindowInput({
  columns,
  limit,
  setLimit,
  sortDirection,
  setSortBy,
  setSortDirection,
  sortBy,
}: {
  columns: { label: string; value: string }[];
  limit: number;
  sortDirection: "ascending" | "descending";
  sortBy: string;
  setLimit(limit: number): void;
  setSortBy(by: string): void;
  setSortDirection(direction: "ascending" | "descending"): void;
}) {
  const disabled = false;
  const options = [
    {
      label: "Default",
      value: "default",
    },
    ...columns.map((column) => ({
      label: attributeToTitle(column.label),
      value: column.value,
    })),
  ];
  return (
    <div style={{ width: "100%" }}>
      <Flex spaceBetween style={{ width: "100%" }}>
        <span className="viz-label">Sort by</span>
        <Select
          popupMatchSelectWidth={false}
          value={sortBy}
          bordered={false}
          className="viz-select"
          onChange={(sortBy) => setSortBy(sortBy)}
          options={options.map((opt) => ({
            ...opt,
            label: <span className="viz-select-option">{opt.label}</span>,
          }))}
        />
      </Flex>
      <Flex spaceBetween style={{ marginTop: 8 }}>
        <span
          className={[
            "viz-label",
            disabled || sortBy === "default" ? "disabled" : "",
          ].join(" ")}
        >
          Direction
        </span>
        <Select
          disabled={disabled || sortBy === "default"}
          bordered={false}
          className={[
            "viz-select",
            disabled || sortBy === "default" ? "disabled" : "",
          ].join(" ")}
          value={sortDirection}
          popupMatchSelectWidth={false}
          onChange={(direction) => setSortDirection(direction)}
          options={[
            {
              value: "ascending",
              label: <span className="viz-select-option">Ascending</span>,
            },
            {
              value: "descending",
              label: <span className="viz-select-option">Descending</span>,
            },
          ]}
        />
      </Flex>
      <Flex spaceBetween style={{ marginTop: 8 }}>
        <span className={["viz-label", disabled ? "disabled" : ""].join(" ")}>
          Limit
        </span>
        <InputNumber
          className="viz-select"
          value={Math.max(0, limit) || "none"}
          onChange={(limit) =>
            setLimit(limit === "none" ? 0 : Math.max(limit || 0, 0))
          }
        />
      </Flex>
    </div>
  );
}
